import { render, staticRenderFns } from "./CoopGroup.vue?vue&type=template&id=ce66dee4&scoped=true&"
import script from "./CoopGroup.vue?vue&type=script&lang=js&"
export * from "./CoopGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce66dee4",
  null
  
)

export default component.exports